<template>

<div>

  <LDBsTable
    url="bank-account"
    defaultSort="name"
    defaultOrder="asc"
    :query="queryToUse"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
      <Combobox
        class="bg-white"
        name='garage_accredited'
        :placeholder="$t('select_a_item')"
        :options="garages"
        :initial-value="query.garageAccredited"
        label="fantasyName"
        v-model="query.garageAccredited"
        :reduce="garage => garage.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('name') }}</label>
      <input
        type="text"
        class="form-control"
        id="name"
        name="name"
        :placeholder="$t('type_name')"
        v-model="query.name"
      >
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('cpf_cnpj') }}</label>
      <input
        type="text"
        class="form-control"
        id="cpf_cnpj"
        name="cpf_cnpj"
        :placeholder="$t('type_cpf_cnpj')"
        v-model="query.cpfCnpj"
        @input="query.cpfCnpj = query.cpfCnpj.toUpperCase()"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="uf">{{ $t('bank') }}</label>
      <vue-select
        class="bg-white"
        name='bank'
        :placeholder="$t('select_a_item')"
        :options="banks"
        label='name'
        v-model="query.bank"
        :initial-value="query.bank"
        :reduce="bank => bank.id"
        :select-on-tab='true'
      />
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('agency') }}</label>
      <input
        type="text"
        class="form-control"
        id="agency"
        name="agency"
        :placeholder="$t('ph_agency')"
        v-model="query.agency"
      >
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('account') }}</label>
      <input
        type="text"
        class="form-control"
        id="account"
        name="account"
        :placeholder="$t('ph_account')"
        v-model="query.account"
      >
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('pix') }}</label>
      <input
        type="text"
        class="form-control"
        id="pix"
        name="pix"
        :placeholder="$t('ph_pix')"
        v-model="query.pix"
      >
    </div>

    <div class="form-group col-lg-4">
      <label>{{ $t('type_account') }}</label>
      <vue-select
        class="bg-white"
        name="type_account"
        :placeholder="$t('select_a_item')"
        :options="['Corrente', 'Poupança']"
        v-model="query.type"
        :select-on-tab='true'
      />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { maskCpfCnpj } from '@/lib/staticMask'
import { mapState } from 'vuex'

export default {
  name: 'BankAccountList',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccredited',
          formatter: function(value) {
            return value
              ? value.fantasyName
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('cpf_cnpj'),
          field: 'cpfCnpj',
          formatter: maskCpfCnpj,
          sortable: true
        },
        {
          title: this.$t('bank'),
          field: 'bank',
          formatter: function(value) {
            return value.name
          },
          sortable: true
        },
        {
          title: this.$t('agency'),
          field: 'agency',
          sortable: true
        },
        {
          title: this.$t('account'),
          field: 'account',
          sortable: true
        },
        {
          title: this.$t('pix'),
          field: 'pix',
          sortable: true
        },
        {
          title: this.$t('type'),
          field: 'type',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/bankaccount/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'contas_bancarias' }
      },
      query: {
        id: undefined,
        garageAccredited: undefined,
        bank: undefined,
        agency: '',
        account: '',
        type: '',
        name: '',
        cpfCnpj: '',
        pix: ''
      },
      queryToUse: {}
    }
  },

  computed: {
    ...mapState({
      garages: state => state.garageaccredited.all,
      banks: state => state.banks.all,
      lastquery: state => state.filtershistory.query
    })
  },

  methods: {
    clear() {
      this.query.garageAccredited = undefined
      this.query.bank             = undefined
      this.query.agency           = ''
      this.query.account          = ''
      this.query.pix              = ''
      this.query.type             = ''
      this.query.name             = ''
      this.query.cpfCnpj          = ''
    }
  },

  beforeMount() {
    this.queryToUse = this.lastquery['bankaccount'] ? this.lastquery['bankaccount'] : this.query
  },

  async mounted() {
    await this.$store.dispatch('garageaccredited/fetchAll')
    await this.$store.dispatch('banks/fetchAll')

    if (this.lastquery['bankaccount']) {
      for (const [key, value] of Object.entries(this.lastquery['bankaccount'])) {
        this.query[key] = value
      }
    }

    this.queryToUse = this.query
  },

  destroyed () {
    this.$store.dispatch('filtershistory/setQuery', { key: 'bankaccount', query: this.query })
  },
}
</script>
